import React, { useEffect, useState } from 'react'
import { api } from '../lib/api'

export default function PeriodOrgFilter({ orgId, from, to, onChange }) {
    const [orgOptions, setOrgOptions] = useState([])

    useEffect(() => {
        let ignore = false
        async function loadOrgs() {
            try {
                // 로그인 사용자의 조직 + 하위 조직만 조회
                const res = await api.get('/orgs/options', { params: { scope: 'mine' } })
                const data = res?.data?.data ?? res?.data ?? []
                if (!ignore) setOrgOptions(Array.isArray(data) ? data : [])
            } catch {
                if (!ignore) setOrgOptions([])
            }
        }
        loadOrgs()
        return () => { ignore = true }
    }, [])

    const formatDate = (d) => {
        const yyyy = d.getFullYear()
        const mm = String(d.getMonth() + 1).padStart(2, '0')
        const dd = String(d.getDate()).padStart(2, '0')
        return `${yyyy}-${mm}-${dd}`
    }

    const setThisWeek = () => {
        const today = new Date()
        const day = today.getDay() // 0(일)~6(토)
        const mondayDiff = (day + 6) % 7 // 월요일 기준
        const start = new Date(today)
        start.setDate(today.getDate() - mondayDiff)
        const end = new Date(start)
        end.setDate(start.getDate() + 6)
        onChange({
            orgId,
            from: formatDate(start),
            to: formatDate(end),
        })
    }

    const setThisMonth = () => {
        const today = new Date()
        const start = new Date(today.getFullYear(), today.getMonth(), 1)
        const end = new Date(today.getFullYear(), today.getMonth() + 1, 0)
        onChange({
            orgId,
            from: formatDate(start),
            to: formatDate(end),
        })
    }

    return (
        <div className="flex flex-wrap items-center gap-3 text-sm">
            {/* 조직 목록 선택 박스 */}
            <select
                className="rounded border px-3 py-2 text-sm"
                value={orgId || ''}
                onChange={(e) => onChange({ orgId: e.target.value || '', from, to })}
            >
                <option value="">전체 조직</option>
                {orgOptions.map(o => (
                    <option key={o.id} value={o.id}>
                        {o.name}
                    </option>
                ))}
            </select>

            {/* 이번주 / 이번달 버튼 */}
            <button
                type="button"
                className="rounded border px-3 py-2 text-xs hover:bg-slate-50"
                onClick={setThisWeek}
            >
                이번주
            </button>
            <button
                type="button"
                className="rounded border px-3 py-2 text-xs hover:bg-slate-50"
                onClick={setThisMonth}
            >
                이번달
            </button>

            {/* 기간 선택 영역 */}
            <div className="flex items-center gap-1 text-xs text-slate-600">
                {/* <span>기간</span> */}
                <input
                    className="rounded border px-2 py-1 text-xs"
                    type="date"
                    value={from}
                    onChange={(e) => onChange({ orgId, from: e.target.value, to })}
                />
                <span>~</span>
                <input
                    className="rounded border px-2 py-1 text-xs"
                    type="date"
                    value={to}
                    onChange={(e) => onChange({ orgId, from, to: e.target.value })}
                />
            </div>
        </div>
    )
}

